<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        @if (showAvatar && user?.avatar) {
            <img class="h-7 w-7 rounded-full" [src]="user.avatar" />
        }
        @if (!showAvatar || !user?.avatar) {
            <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        }
    </span>
</button>

<mat-menu [xPosition]="'after'" [yPosition]="'below'" #userActions="matMenu" class="user-menu-modern">
    <button mat-menu-item disabled class="!cursor-default">
        <span class="flex flex-col leading-none">
            <span class="text-xs text-gray-500 dark:text-gray-400">Sesión iniciada como</span>
            <span class="mt-1.5 text-sm font-medium">{{ user?.email }}</span>
        </span>
    </button>

    <!-- Selector de corporativo (solo si el usuario tiene >1) -->
    @if (hasMultipleTenants) {
        <mat-divider class="my-2"></mat-divider>
        <div class="px-4 pb-1 pt-2 text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Cambiar de corporativo
        </div>
        @for (t of tenants; track t.tenantId) {
            <button
                mat-menu-item
                class="!h-auto !min-h-[44px]"
                [disabled]="switchingTenant"
                (click)="switchTenant(t.tenantId)">
                @if (t.logoUrl) {
                    <img class="mr-3 h-6 w-6 rounded" [src]="t.logoUrl" [alt]="t.name" />
                }
                @if (!t.logoUrl) {
                    <mat-icon class="mr-3 text-gray-500" [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
                }
                <span class="flex-1 truncate">{{ t.name }}</span>
                @if (isCurrentTenant(t.tenantId)) {
                    <mat-icon class="ml-2 text-primary" [svgIcon]="'heroicons_outline:check-circle'"></mat-icon>
                }
                @if (!isCurrentTenant(t.tenantId) && switchingTenant) {
                    <mat-spinner diameter="16" class="ml-2"></mat-spinner>
                }
            </button>
        }
    }

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Cerrar sesión</span>
    </button>
</mat-menu>
